/* Comment to stop lint from being stupid */
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import moment from 'moment';

export default function MemberInfo({ 
  labelNameOnCard,
  invoiceNumber,
  name,
  fromDate,
  through,
  lastNameEndsWith,
  invoiceNumberValue,
  membershipFeeAmt,
  membershipPeriod
}) {
  return (
    <Container style={{ padding: 0 }}>
      <Row className="info-size" style={{ paddingTop: '5px' }}>
        <Col md={5} xs={6}>
          {lastNameEndsWith}
        </Col>
        <Col md={7} xs={6}>
          {name}
        </Col>
      </Row>
      <Row className="info-size">
        <Col md={5} xs={6}>{membershipPeriod}</Col>
        <Col md={7} xs={6}>
            {fromDate && ` ${moment(new Date(fromDate)).format('MM/DD/YYYY')} 
                          ${through} ${moment(new Date(fromDate))
              .add(1, 'year')
              .format('MM/DD/YYYY')}`}
        </Col>
      </Row>
      <Row className="info-size">
        <Col md={5} xs={6}>{invoiceNumber}</Col>
        <Col md={7} xs={6}>{invoiceNumberValue}</Col>
      </Row>
    </Container>
  );
}
